// extracted by mini-css-extract-plugin
export default {"modal":"ModalContacto_modal__2UTx8","modal-footer":"ModalContacto_modal-footer__I7nAM"};